import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Text } from 'components/base'
import { selectors as ConfigSelectors } from 'data/config'

class Informations extends Component {
  renderSSOStatus() {
    const { organization, apiEndpoint } = this.props
    const teamURL = `https://${organization.domain}.slite.com`
    const apiLoginURL = `${apiEndpoint}/auth/openid/login?organizationId=${
      organization.id
    }`
    const isGoogleSSO = organization.get('authMethod') === 'google'
    const ssoService = isGoogleSSO
      ? 'Google SSO'
      : organization.authProvider.get('name')
    return (
      <React.Fragment>
        <div className="flexbox flexbox-align-center padding-large border-small border-green radius-normal background-shade-100 margin-bottom-larger">
          <div className="flexbox-grow shade-10">
            Your team is currently configured to use {ssoService}
          </div>
        </div>
        {!isGoogleSSO && (
          <div className="shade-10 line-height-larger flexbox flexbox-wrap">
            Your team can access Slite at
            <Text.ExternalLink className="margin-horizontal-smaller">
              {teamURL}
            </Text.ExternalLink>
            or, alternatively you can direct them to
            <Text.ExternalLink className="margin-horizontal-smaller">
              {apiLoginURL}
            </Text.ExternalLink>
            to directly initiate the SSO login experience.
          </div>
        )}
      </React.Fragment>
    )
  }

  render() {
    const { organization } = this.props
    return (
      <div className="margin-bottom-larger">
        {organization.get('authMethod') !== 'emailPassword' &&
          this.renderSSOStatus()}
      </div>
    )
  }
}

export default connect(state => ({
  apiEndpoint: ConfigSelectors.getApiEndpoint(state),
}))(Informations)
